import { render, staticRenderFns } from "./WxAccountModal.vue?vue&type=template&id=0baeaa14&"
import script from "./WxAccountModal.vue?vue&type=script&lang=js&"
export * from "./WxAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports